import { render, staticRenderFns } from "./GamerProfile.vue?vue&type=template&id=452273b2"
import script from "./GamerProfile.vue?vue&type=script&lang=js"
export * from "./GamerProfile.vue?vue&type=script&lang=js"
import style0 from "./GamerProfile.vue?vue&type=style&index=0&id=452273b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports